export default __webpack_public_path__ + "static/media/rolls-royce.5383eb72.jpg";